'use strict';

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import wrapWords from '../../../src/js/shared/wrapWords';

const $ = jQuery.noConflict();
$(function() {

	const signaturePrograms = {

		init: function() {
			this.cacheDOM();
			if (!this.section) {
				return;
			}
			this.wrapIntroWords();
			if (this.prefersReducedMotion()) {
				return;
			}
			gsap.registerPlugin(ScrollTrigger);
			ScrollTrigger.config({ignoreMobileResize: true});
			this.animateIntro();
		},

		cacheDOM: function() {
			this.section = document.querySelector('.js-signature-programs');
			if (!this.section) {
				return;
			}
			this.intro = this.section.querySelector('.js-signature-programs-intro');
		},

		prefersReducedMotion: function() {
			return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		},

		wrapIntroWords: function() {
			if (!this.intro) {
				return;
			}
			wrapWords.wrap([this.intro], 'signature-programs__intro-word', 'js-signature-programs-intro-word');
			this.introWords = this.section.querySelectorAll('.js-signature-programs-intro-word');
		},

		animateIntro: function() {
			if (!this.intro) {
				return;
			}

			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: this.intro,
					start: 'top 80%',
					end: 'bottom 40%',
					scrub: 0.3,
				},
			});

			tl.fromTo(this.intro, {opacity: 0}, {
				opacity: 1,
				duration: 2,
			}, 0);

			if (this.introWords && this.introWords.length) {
				tl.fromTo(this.introWords, {opacity: 0.2}, {
					opacity: 1,
					ease: 'none',
					stagger: {each: 0.04, from: 'start'},
					duration: 0.2,
				}, 1);
			}
		},

	};

	signaturePrograms.init();
});
